import {zip} from 'd3-array';
import {countMeasure, mixedMeasure} from '../default/';
import {conditions} from './';
import {ConditionException} from '../../modules/error';
import {stack} from '../../modules/transform';

function _munge() {//데이터 갱신시
  //TODO: Limit 기능 이용해서 dimension의 unique한 개수 조절
  let conditionFunc = function (dimensions, measures) {
    const field = this.__execs__.field;
    if (dimensions.length <= 2 && measures.length === 0) {
      if(dimensions[1]) field.region = dimensions[1];
      field.x = dimensions[0];
      this.measure(countMeasure); //count 모드일때는 가짜 measure 추가
      field.y = measures[0];
      return conditions[1];
    } else if (dimensions.length <= 2 && measures.length === 1) {
      if(dimensions[1]) field.region = dimensions[1];
      field.x = dimensions[0];
      field.y = measures[0];
      return conditions[0];
    } else if (dimensions.length === 1 && measures.length >= 2) {
      field.region = this.mixedDimension();
      field.x = dimensions[0];
      field.y = mixedMeasure;
      return conditions[2];
    }
    else throw new ConditionException();
  };
  this.condition(conditionFunc); // condiion 설정
  const field = this.__execs__.field;
  const mixed = this.isMixed();
  if (this.aggregated()) {
    this.__execs__.munged = [this.data().copy()];
  } else if (mixed) { //바와는 반대로 처리
    this.__execs__.munged = this.aggregateMixed(true);//가짜 dimension과 measure로 처리
  } else {
    this.__execs__.munged = this.aggregate(true);
    if (!this.isNested()) {
      this.__execs__.munged = [this.__execs__.munged[0].parent];
    } 
  }

  if (this.stacked() && this.isNested()) { // mixed 아닐때는 동일
    let munged = this.__execs__.munged;
    let valuesZipped = munged.map(d => d.children);
    valuesZipped = zip.apply(null, valuesZipped);
    //TODO: 2번째 dimension의 개수가 동일한지 확인
    //bar와는 스택구조가 반대이므로 zip 통해서 임시 구조 만듦
    valuesZipped.forEach(d => {
      stack(d, field.y, false, this.normalized());
    })
  }
}

export default _munge;


// WEBPACK FOOTER //
// ./layouts/line/_munge.js